import { Helmet } from "react-helmet";
import { Link } from "wouter";
import { Button } from "../components/ui/button";

const successStories = [
  {
    name: "Osteria Milano",
    city: "Milan, Italy",
    quote:
        "“Partnering with SurpriseTable filled our off-peak nights. We see new faces every week, and many surprise guests have returned—some became regulars! The whole process is seamless, and we get paid on time, every time.”",
    image: "https://images.pexels.com/photos/170189/pexels-photo-170189.jpeg", // replace with your partner's real photo if available
    stats: [
      { label: "Avg. New Guests/Month", value: "+40" },
      { label: "Repeat Visits", value: "60%" },
      { label: "Revenue Increase", value: "+18%" },
    ],
  },
  {
    name: "Café Zeitlos",
    city: "Berlin, Germany",
    quote:
        "“SurpriseTable brings us curious diners who want to try something new. Our surprise menu gets rave reviews. Their platform handles everything—even dietary requests—so our team can focus on the guest experience.”",
    image: "https://images.pexels.com/photos/262047/pexels-photo-262047.jpeg",
    stats: [
      { label: "No-Show Rate", value: "<1%" },
      { label: "Positive Feedback", value: "98%" },
      { label: "Off-Peak Table Fills", value: "+22/mo" },
    ],
  },
  {
    name: "Le Bistrot Secret",
    city: "Paris, France",
    quote:
        "“We love the surprise concept. Every guest arrives with a sense of adventure. SurpriseTable made it easy to onboard, and we’re seeing real growth in our bookings.”",
    image: "https://images.pexels.com/photos/6267/menu-restaurant-vintage-table.jpg",
    stats: [
      { label: "Setup Time", value: "10 min" },
      { label: "Increase in Online Reviews", value: "+37%" },
      { label: "Avg. Spend Above Minimum", value: "€7" },
    ],
  },
];

const SuccessStories = () => (
    <>
      <Helmet>
        <title>Success Stories | SurpriseTable</title>
        <meta
            name="description"
            content="Discover how restaurants across Europe are filling tables, delighting guests, and growing their business with SurpriseTable. Real results. Real partners."
        />
      </Helmet>

      <section className="bg-white py-16 transition-colors duration-200 dark:bg-gray-900">
        <div className="container mx-auto px-4">
          <div className="mb-14 text-center max-w-3xl mx-auto">
            <h1 className="mb-4 font-serif text-4xl md:text-5xl font-bold text-gray-800 dark:text-white">
              Success Stories from <span className="text-primary">Our Partners</span>
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-gray-600 dark:text-gray-300">
              See how restaurants are using SurpriseTable to fill seats, boost revenue, and create memorable guest experiences.
            </p>
          </div>

          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
            {successStories.map((story, idx) => (
                <div
                    key={story.name}
                    className="rounded-xl bg-gray-100 p-6 dark:bg-gray-800 shadow-lg flex flex-col"
                >
                  <img
                      src={story.image}
                      alt={story.name}
                      className="h-44 w-full object-cover rounded-lg mb-6"
                      style={{ minHeight: "176px" }}
                      loading="lazy"
                  />
                  <div className="mb-4">
                    <h3 className="font-serif text-xl font-bold text-gray-800 dark:text-white">
                      {story.name}
                    </h3>
                    <span className="block text-primary font-medium text-sm mb-2">{story.city}</span>
                  </div>
                  <p className="italic text-gray-700 dark:text-gray-300 flex-1 mb-4">
                    {story.quote}
                  </p>
                  <div className="flex flex-wrap gap-4 mt-auto">
                    {story.stats.map((stat) => (
                        <div
                            key={stat.label}
                            className="flex flex-col items-center px-3 py-2 rounded bg-white dark:bg-gray-900 shadow text-center flex-1 min-w-[110px]"
                        >
                          <span className="text-xl font-bold text-primary">{stat.value}</span>
                          <span className="text-xs text-gray-500 dark:text-gray-400">{stat.label}</span>
                        </div>
                    ))}
                  </div>
                </div>
            ))}
          </div>

          <div className="mt-20 text-center">
            <h2 className="mb-6 text-2xl font-bold text-gray-800 dark:text-white">
              Want to Be Our Next Success Story?
            </h2>
            <p className="mb-4 text-lg text-gray-700 dark:text-gray-300">
              SurpriseTable is trusted by independent bistros, award-winning chefs, and local favorites.
              Your empty tables are opportunity—let us fill them.
            </p>
            <Button
                asChild
                className="inline-block rounded-lg bg-primary px-10 py-4 text-lg font-bold text-white hover:bg-red-700"
                size="lg"
            >
              <Link href="/partner">Become a Partner</Link>
            </Button>
            <div className="mt-4 text-xs text-gray-400">
              Got questions? <Link href="/contact" className="underline hover:text-primary">Contact our partnership team</Link>
            </div>
          </div>
        </div>
      </section>
    </>
);

export default SuccessStories;
